export default "__VITE_ASSET__f6d9aa1f__"